<template>
    <section v-if="$root.globalData" id="helpToAccessLocation">
      <template v-if="!choiceOS">
        <h3>
          {{ $root.globalData.keys.first_help_text }}
            
        </h3>
        <div class="d-flexCenter">
            <button @click="choiceOS='ios'" class="choseOS">
            <img src="@/assets/images/iosIcon.png" alt="ios">
            <span>
                ios
            </span>
            </button>
            <button  @click="choiceOS='android'"  class="choseOS">
                <img src="@/assets/images/androidIcon.png" alt="android">
                <span> 
                    android
                </span>
                </button>
        </div>
      </template>
      <template v-else>
         <template  v-if="!choiceBrowser">
            <h3>
          {{ $root.globalData.keys.first_step_help_text }}

            </h3>
            <p v-html="$root.globalData.keys.access_to_gps_text " class="firstSetting" dir="rtl" />
            <img class="firstSetting" :src="choiceOS=='ios'?iosFirstSettingImage:androidFirstSettingImage" alt="set default setting to access gps">
            <h3>
          {{ $root.globalData.keys.choice_browser }}

               
            </h3>
            <p v-if="choiceOS=='ios'" class="firstSetting" dir="rtl">
          {{ $root.globalData.keys.choice_browser_description_ios }}

            </p>
            <p v-else class="firstSetting" dir="rtl">
          {{ $root.globalData.keys.choice_browser_description_android }}
              
            </p>
            <div  class="d-flexCenter">
              
              
                <button v-if="choiceOS=='ios'" @click="choiceBrowser='safari'" class="choseOS">
                  <img src="@/assets/images/safariIcon.png" alt="chrome">
                  safari
              </button>
              
              <button @click="choiceBrowser='chrome'" class="choseOS">
                  <img src="@/assets/images/chromeIcon.png" alt="chrome">
                  chrome
              </button>
            </div>
         </template>
         <template v-else>
            <h3>
          {{ $root.globalData.keys.access_to_location_header }}

          </h3>
          <p class="firstSetting">
          {{ $root.globalData.keys.access_to_location_description }}

          </p>
         <template v-if="choiceBrowser=='safari'">
     
          <h4>
          {{ $root.globalData.keys.safari_access_to_location_1 }}

          </h4>
          <img class="rahnamaImage" src="@/assets/images/iphone1.png" alt="iphone location">
          <h4>
          {{ $root.globalData.keys.safari_access_to_location_2 }}

          </h4>
          <img class="rahnamaImage" src="@/assets/images/iphone2.png" alt="iphone location">
          <h4>
          {{ $root.globalData.keys.safari_access_to_location_3 }}

          </h4>
          <img class="rahnamaImage" src="@/assets/images/iphone3.png" alt="iphone location">
          <h4>
          {{ $root.globalData.keys.safari_access_to_location_4 }}

          </h4>
          <img class="rahnamaImage" src="@/assets/images/iphone4.png" alt="iphone location">
          <h4>
          {{ $root.globalData.keys.safari_access_to_location_5 }}

          </h4>
          <img class="rahnamaImage" src="@/assets/images/iphone7.png" alt="iphone location">
         </template>
         
         <template v-else-if="choiceBrowser=='chrome'&&choiceOS=='ios'">
     
     <h4>
      {{ $root.globalData.keys.iphone_chrome_access_to_location_1 }}

     </h4>
     <img class="rahnamaImage" src="@/assets/images/iphone1.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.iphone_chrome_access_to_location_2 }}

     </h4>
     <img class="rahnamaImage" src="@/assets/images/iphone5.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.iphone_chrome_access_to_location_3 }}

     </h4>
     <img class="rahnamaImage" src="@/assets/images/iphone6.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.iphone_chrome_access_to_location_4 }}

     </h4>
     <img class="rahnamaImage" src="@/assets/images/iphone8.png" alt="iphone location">
    </template>
     
    <template v-else-if="choiceBrowser=='chrome'&&choiceOS=='android'">
     
     <h4>
      {{ $root.globalData.keys.chrome_access_to_location_1 }}

     </h4>     
        <p class="firstSetting">
          {{ $root.globalData.keys.choice_browser_description_android }}

          </p>
     <img class="rahnamaImage" src="@/assets/images/Android1.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.chrome_access_to_location_2 }}

     </h4>
     <img class="rahnamaImage" src="@/assets/images/Android2.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.chrome_access_to_location_3
       }}

       <br>
       <q>
        {{ $root.globalData.keys.chrome_access_to_location_31
       }}
       </q>
     </h4>
     <img class="rahnamaImage" src="@/assets/images/Android3.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.chrome_access_to_location_4
       }}
     </h4>
     <img class="rahnamaImage" src="@/assets/images/Android4.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.chrome_access_to_location_5
       }}
        <br>
        <q>
          {{ $root.globalData.keys.chrome_access_to_location_51
       }}
        </q>
     </h4>
     <img class="rahnamaImage" src="@/assets/images/Android5.png" alt="iphone location">
     <h4>
      {{ $root.globalData.keys.chrome_access_to_location_6
       }}
 </h4>
     <img class="rahnamaImage" src="@/assets/images/Android6.png" alt="iphone location">
    </template>
          <h3>
            {{ $root.globalData.keys.last_text_to_help_access
       }}
          </h3>
          <router-link :to="$route.query.fromUnit?'/unit/'+$route.query.fromUnit:'/industry'" class="backToUnit">
            {{ $root.globalData.keys.back_to_unit_from_access_page
       }}
           
          </router-link>
         </template>
        </template>
    </section>
</template>
<script>
    import androidFirstSettingImage from "@/assets/images/androidFirstSetting.webp"
    import iosFirstSettingImage from "@/assets/images/iphoneFirstSetting.webp"
    export default{
        data(){
            return{
                androidFirstSettingImage:androidFirstSettingImage,
                iosFirstSettingImage:iosFirstSettingImage,
                choiceOS:null,
                choiceBrowser:null,
            }
        }
    }
</script>
<style scoped>
  #helpToAccessLocation{
    min-height: 100vh;
  }
h3,h4{
    text-align: center;
    margin: 24px 0;
    direction: rtl;
}
.d-flexCenter{
    display: flex;

    justify-content: center;
    width:95%;
    gap: 16px;
    margin: auto;

}
.d-flexCenter button{
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}
q{
    display: block;
}
.firstSetting,q{
    width: 95%;
    margin:8px auto;
}
.rahnamaImage{
    height: 70vh;
    width: auto;
    margin: 8px auto;
}
a.backToUnit {
    background: blue;
    padding: 8px;
    color: white;
    border-radius: 8px;
    font-size: 13px;
}
</style>